/* eslint-disable @typescript-eslint/no-explicit-any */
import { ApiService } from 'app/api';
import { IApplicationContext } from 'app/context/types';
import { ICreateSentence, ISentence } from '../interfaces/sentence';
import { SearchSentencesFieldsForm } from '../components/SentencesSearchBar';
import { Region } from 'modules/RegionsConfiguration/constants/enums';

export class SentencesService {
	private apiService: ApiService;

	constructor(private applicationContext: IApplicationContext) {
		this.apiService = new ApiService(this.applicationContext);
	}

	getSentenceById(sentenceId: number) {
		return new Promise((resolve, reject) =>
			this.apiService
				.invoke(
					this.applicationContext.getApiConfig().SENTENCES.GET_SENTENCE,
					null,
					{ reqPathParam: sentenceId },
				)
				.then(({ data }: any) => {
					resolve(data);
				})
				.catch((error: Error) => {
					reject(error);
				}),
		);
	}
	addSentence(newSentenceData: ISentence) {
		return new Promise((resolve, reject): Promise<void> => {
			return this.apiService
				.invoke(
					this.applicationContext.getApiConfig().SENTENCES.CREATE_SENTENCE,
					this.formatSentenceReqData(newSentenceData),
				)
				.then((result: any) => {
					resolve(result);
				})
				.catch((error: any) => {
					reject(error);
				});
		});
	}
	updateSentence(sentenceToUpdateData: ISentence) {
		return new Promise((resolve, reject): Promise<void> => {
			return this.apiService
				.invoke(
					this.applicationContext.getApiConfig().SENTENCES.UPDATE_SENTENCE,
					this.formatSentenceReqData(sentenceToUpdateData),
				)
				.then((result: any) => {
					resolve(result);
				})
				.catch((error: any) => {
					reject(error);
				});
		});
	}
	getSentences(
		page: number,
		{ sentenceNameSearchKey }: SearchSentencesFieldsForm,
	) {
		return new Promise((resolve, reject) => {
			this.apiService
				.invoke(
					this.applicationContext.getApiConfig().SENTENCES.GET_SENTENCES,
					{},
					{
						pathParams: { page: page || 1, searchKey: sentenceNameSearchKey },
					},
				)
				.then(({ data }: any) => {
					resolve(data);
				})
				.catch((error: Error) => {
					reject(error);
				});
		});
	}

	searchSentencesAutoComplete({
		sentenceNameSearchKey,
	}: SearchSentencesFieldsForm) {
		return new Promise((resolve, reject) =>
			this.apiService
				.invoke(
					this.applicationContext.getApiConfig().SENTENCES.SEARCH_SENTENCES,
					{},
					{
						pathParams: {
							searchKey: sentenceNameSearchKey,
						},
					},
				)
				.then(({ data }: any) => {
					resolve(data);
				})
				.catch((err: Error) => {
					reject(err);
				}),
		);
	}

	deleteSentence(sentenceId: number) {
		return this.apiService.invoke(
			this.applicationContext.getApiConfig().SENTENCES.DELETE_SENTENCE,
			null,
			{ reqPathParam: sentenceId },
		);
	}

	searchByPreviousLessonsAutoComplete(pathParams: {
		searchKey: string;
		region: Region;
		order: number;
	}) {
		return new Promise((resolve, reject) =>
			this.apiService
				.invoke(
					this.applicationContext.getApiConfig().SENTENCES
						.SEARCH_BY_PREVIOUS_LESSONS,
					{},
					{
						pathParams,
					},
				)
				.then(({ data }: any) => {
					resolve(data);
				})
				.catch((err: Error) => {
					reject(err);
				}),
		);
	}

	private formatSentenceReqData({
		strengtheningAudio,
		sentenceWords,
		id,
		name,
	}: ISentence): ICreateSentence {
		return {
			...(id ? { id } : {}),
			name,
			strengtheningAudioId: strengtheningAudio.id,
			sentenceWords: sentenceWords.map(word => ({
				...(word.id ? { id: word.id } : {}),
				order: word.order,
				vocabWordId: word?.vocabWord?.id,
			})),
		};
	}
}
